import types from '@/types';

const createZoneModule = (zoneService) => ({
  namespaced: true,
  state: {
    zones: [],
  },

  mutations: {
    [types.SET_ZONES](state, zones) {
      state.zones = zones;
    },
  },

  actions: {
    [types.GET_ZONES]({ commit }) {
      return zoneService.getSelectOptions()
        .then((response) => {
          commit(types.SET_ZONES, response.data);
        });
    },
  },
});

export default createZoneModule;



// WEBPACK FOOTER //
// ./src/store/modules/zone.js